const DateTimeFunc = require('@/tbs/util/DateTimeFunc')
const Common = require('@/tbs/model/to/Common')

const common = new Common
/**
 * The Organization class acts as the view object for the organization.
 */
const tbs_model_vo_OrganizationManager = function() {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_OrganizationManager.prototype = {
    /* The view object name */
    name: 'organizationManager',
    /* The entity source */
    view: {
        manage: [
            {
                name: 'organization',
                baseUrl: process.env.VUE_APP_BANMA_API,
                apiPrefix: '/bmmatch/',
                service: 'GetCrmAccount2',
                query: {
                    id: 'id'
                },
                basePath: 'data.account',
                rule: {
                    id: '~id',
                    name: 'name',
                    logoUrl: 'logo',
                    duration: '$createDate',
                    area: '$country,province,city,district',
                    areaId: '$countryId,provinceId,cityId,districtId',
                    authStatus: '$certificationStatus'
                }
            },
            {
                name: 'matchList',
                baseUrl: process.env.VUE_APP_BANMA_API,
                apiPrefix: '/bmmatch/',
                service: 'GetUnionManageMatchList2',
                query: {
                    orgId: 'id'
                },
                basePath: 'data.list',
                rule: {
                    id: 'id',
                    name: 'chineseName',
                    status: '$state',
                    logoUrl: 'icon',
                    sportsType: 'sportType',
                    periodDate: '$beginDate,endDate',
                    duration: '$createDate',
                    isBangSaiShi: 'isBangSaiShi'
                }
            },
            {
                name: 'role',
                baseUrl: process.env.VUE_APP_BANMA_API,
                apiPrefix: '/bmmatch/',
                service: 'GetCrmAccountMyManagerRole',
                query: {
                    accountId: 'id'
                },
                basePath: 'data',
                rule: {
                    isManager: '@isManager',
                    isMatchManager: '@isMatchManager',
                    isReferee: '@isReferee',
                }
            },
        ],
    },
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
    renderAuthStatus: function(certificationStatus) {
        if (certificationStatus == -2) {
            return '1'
        }
        else if (certificationStatus == -1) {
            return '4'
        }
        else if (certificationStatus == 0) {
            return '2'
        }
        else if (certificationStatus == 1) {
            return '3'
        }
        else {
            return '1'
        }
    },
    renderArea: function(country, province, city, district) {
        let area = ''
        if (country && !province) {
            area = country
        }
        else {
            area = province
        }
        if (city) {
            area += ' ' + city
        }
        if (district) {
            area += ' ' + district
        }
        return area
    },
    renderAreaId: function(countryId, provinceId, cityId, districtId) {
        let areaId = countryId
        if (provinceId) {
            areaId = provinceId
        }
        if (cityId) {
            areaId = cityId
        }
        if (districtId) {
            areaId = districtId
        }
        return areaId
    },
    renderDuration: function(createDate) {
        const createTime = new Date(createDate).getTime()
        const oneDay = 24 * 60 * 60 * 1000
        const oneMonth = 30 * oneDay
        const oneYear = 365 * oneDay 
        const now = (new Date).getTime()
        const durationTimestamp = now - createTime
        if (durationTimestamp >= oneYear) {
            return {
                unit: '${year}',
                num: Math.ceil(durationTimestamp / oneYear)
            }
        }
        else if (durationTimestamp >= oneMonth) {
            return {
                unit: '${month}',
                num: Math.ceil(durationTimestamp / oneMonth)
            }
        }
        else {
            return {
                unit: '${day}',
                num: Math.ceil(durationTimestamp / oneDay)
            }
        }
    },
    renderPeriodDate: function(startDate, endDate) {
        startDate = new Date(startDate).getTime()
        if (endDate) {
            endDate = new Date(endDate).getTime()
        }
        let startDateStr = DateTimeFunc.formatUTCTime(startDate, 'yyyy/mm/dd')
        let endDateStr = DateTimeFunc.formatUTCTime(endDate, 'yyyy/mm/dd')
        const currentYearStr = new Date().getFullYear().toString()
        if (startDateStr && startDateStr.startsWith(currentYearStr)) {
            startDateStr = startDateStr.substr(5)
        }
        if (endDateStr && endDateStr.startsWith(currentYearStr)) {
            endDateStr = endDateStr.substr(5)
        }
        if (endDateStr === '') {
            endDateStr += common.localeProp('empty-date-field')
        }
        return common.localeProp('date-period', {startDate: startDateStr, endDate: endDateStr})
    },
    renderStatus: function(state) {
        return (state + 1).toString()
    }
}

module.exports = tbs_model_vo_OrganizationManager